
import React, { useState } from "react";
import PageLayout from "@/components/layout/PageLayout";
import SearchForm from "@/components/recipe-finder/SearchForm";
import SearchResults from "@/components/recipe-finder/SearchResults";
import { useRecipeSearch } from "@/hooks/useRecipeSearch";
const RecipeFinder = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [extractingUrl, setExtractingUrl] = useState<string | undefined>(undefined);
  const [suggestionId, setSuggestionId] = useState<string | undefined>(undefined);
  
  const { 
    results, 
    isLoading, 
    errorMessage, 
    searchAttempted,
    handleSearch 
  } = useRecipeSearch();

  // Direct collapse calculation - no timing issues
  const shouldCollapseIngredients = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const hasQuery = !!urlParams.get('q');
    const hasSuggestionId = !!urlParams.get('suggestion_id');
    const isMobileScreen = window.innerWidth < 768;
    
    return isMobileScreen && (hasQuery || hasSuggestionId);
  };

  // Extract query params on component mount
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');
    const sugId = urlParams.get('suggestion_id');
    
    if (query) {
      setSearchQuery(query);
      // Auto-search if query is provided
      handleSearch(query, [], []);
    }
    
    if (sugId) {
      setSuggestionId(sugId);
    }
  }, []);

  const handleSearchSubmit = async (query: string, ingredients: string[], excludedIngredients: string[] = []) => {
    await handleSearch(query, ingredients, excludedIngredients);
    setSearchQuery(query);
  };

  const handleExtractRecipe = (url: string) => {
    setExtractingUrl(url);
  };

  const handleRecipeAdded = () => {
    // Don't clear extractingUrl here - let the success dialog handle it
    // This callback is just for refreshing data
  };

  const handleImportComplete = () => {
    // Clear the extracting URL after the success dialog is handled
    setExtractingUrl(undefined);
  };

  return (
    <PageLayout
      title="Recipe Finder"
    >
      <div className="grid md:grid-cols-[300px_1fr] gap-6">
        <div className="space-y-6">
          <SearchForm 
            onSearch={handleSearchSubmit} 
            isLoading={isLoading}
            initialQuery={searchQuery}
            collapsedByDefault={shouldCollapseIngredients()}
          />
        </div>
        
        <div className="space-y-4">
          <SearchResults 
            results={results} 
            isLoading={isLoading} 
            errorMessage={errorMessage} 
            searchAttempted={searchAttempted} 
            onExtractRecipe={handleExtractRecipe}
            extractingUrl={extractingUrl}
            onRecipeAdded={handleRecipeAdded}
            onImportComplete={handleImportComplete}
            suggestionId={suggestionId}
          />
        </div>
      </div>
    </PageLayout>
  );
};

export default RecipeFinder;
